import { TRAYECTOS_PROMEDIO_DIA } from "../components/CotizadorProgrammaticCalculadora/constants";
import { esOperativoComercial } from "./getEdificiosOperativos";

// Cantidad de empresas de un edificio a partir de `empresaslistado` (string separado por comas;
// vacío/"NO DISPONIBLE" = 0). Fuente única (10.1) — antes vivía duplicada como
// `calculateEmpresasCantidad` dentro de InventarioAvanzado; ese componente ahora importa esta misma
// función (mismo resultado exacto, cero cambio de comportamiento).
export const contarEmpresasEdificio = (empresaslistado) => {
  if (!empresaslistado || empresaslistado.toUpperCase() === "NO DISPONIBLE") {
    return 0;
  }
  return empresaslistado.split(",").length;
};

// Fuente única del resumen "edificios operativos + en instalación / pantallas totales" de la red
// comercial pública (regla 10.1) — antes vivía inline en InventarioAvanzado. Función pura sobre un
// array de edificios ya cargado (mismo criterio que /inventario: quien la llama decide si pasa el
// listado completo o uno ya filtrado por UI, el cálculo no vuelve a pedir datos).
export const calcularResumenRedComercial = (edificios) => {
  const lista = edificios || [];
  const totalOperativos = lista.filter(esOperativoComercial).length;
  const totalInstalacion = lista.filter((e) => e.estado === "INSTALACIÓN").length;
  const totalPantallas = lista.reduce(
    (sum, e) => sum + (e.pantallas || 0) + (e.totems || 0) + (e.espera || 0) + (e.cowork || 0),
    0
  );

  // Desglose SOLO operativos (sin instalación) — mismas columnas que /inventario (PERSONAS ÚNICAS,
  // EMPRESAS, PANTALLAS TOTAL), filtradas a esOperativoComercial. Lo usa la lámina 3 del mediakit v2
  // (bloque "HOY") — mismo cálculo exacto, nunca reimplementado (10.1). Verificado contra la DB real
  // (Chile, 2026-09-27): 45 edificios, 191 pantallas, 59.199 personas, 985 empresas.
  const edificiosOperativos = lista.filter(esOperativoComercial);
  const pantallasOperativos = edificiosOperativos.reduce(
    (sum, e) => sum + (e.pantallas || 0) + (e.totems || 0) + (e.espera || 0) + (e.cowork || 0),
    0
  );
  const personasOperativos = edificiosOperativos.reduce((sum, e) => sum + (e.personas || 0), 0);
  const empresasOperativos = edificiosOperativos.reduce((sum, e) => sum + contarEmpresasEdificio(e.empresaslistado), 0);

  // Contactos diarios = personas únicas operativas × trayectos promedio por día — misma constante
  // que usa el cotizador programático (TRAYECTOS_PROMEDIO_DIA, nunca copiar el 7.48 acá — 10.1).
  // Lo usa la lámina 3 del mediakit v2 (fila 2, "más grande que compra el anunciante"). Verificado
  // contra la DB real (Chile, 2026-09-27): 59.199 × 7.48 = 442.809 (redondeo al entero).
  const contactosDiariosOperativos = Math.round(personasOperativos * TRAYECTOS_PROMEDIO_DIA);

  return {
    totalOperativos,
    totalInstalacion,
    totalEdificios: totalOperativos + totalInstalacion,
    totalPantallas,
    pantallasOperativos,
    personasOperativos,
    empresasOperativos,
    contactosDiariosOperativos,
  };
};
